/**
 * @file Modal actions.
 */

import getLogger from '../util/logger';
import {
  CONFIRM_MODAL,
  CONFIRM_MODAL_WITH_PASSWORD,
  ALERT_MODAL,
} from '../constants/modals';

const log = getLogger('ModalActions');

export const OPEN_MODAL = 'modal/OPEN';
export const CLOSE_MODAL = 'modal/CLOSE';

const openModalAction = (name, props) => {
  return { type: OPEN_MODAL, name, props };
};

const closeModalAction = name => {
  return { type: CLOSE_MODAL, name };
};

export const openModal = (name, props) => dispatch => {
  log.info('openModal() :: Opening modal...', name);

  dispatch(openModalAction(name, props));
};

export const closeModal = name => dispatch => {
  log.info('closeModal() :: Closing modal...', name);

  dispatch(closeModalAction(name));
};

export const requestConfirm = options => dispatch => {
  dispatch(openModal(CONFIRM_MODAL, options));
};

export const requestConfirmWithAccountPassword = options => dispatch => {
  dispatch(openModal(CONFIRM_MODAL_WITH_PASSWORD, options));
};

/**
 * @function openAlert
 * Opens an alert for the user.
 *
 * @param {Object|String} options List of options, or just the message.
 * @param {String} [options.type=error] The type of the alert.
 * @param {String} [options.title] The title of the alert.
 * @param {Object|String} [options.message] Message displayed on the alert.
 * @param {function} [options.onDismiss] Callback to be triggered on dismiss.
 *
 */
export const openAlert =
  (options = {}) =>
  dispatch => {
    const alertOptions =
      typeof options === 'string' ? { message: options } : options;

    dispatch(openModal(ALERT_MODAL, alertOptions));
  };
